import React from 'react';
import SidebarUnitDesktop from "components/sidebar/components/SidebarUnitDesktop";
import {DocumentIcon} from "assets/icons";

const InvoiceLink = () => {
    return (
        <SidebarUnitDesktop 
            routeName={"Factures"} 
            routeSidebar={"/invoice/toBeSet"}
            icon={DocumentIcon}
            text={"Factures"}
        />
    );
};

export default InvoiceLink;

